module.exports = __webpack_public_path__ + "img/ico_menual08_on.c1610f05.svg";